module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/10_1bf89d2c9a5b9fce212109cb3647d423.jpg";